// Common options object used for most Tabulation table components
export default {
    // These functions must be implemented in options in order to make Tabulator's
    // download functionality work. See https://github.com/ngduc/react-tabulator/issues/76
    downloadDataFormatter: (data) => data,
    downloadReady: (fileContents, blob) => blob,
    /*
        TODO: we're using this callback to fix a couple of minor a11y issues that might be fixed by updating
        react-tabulator to a version which implements tabulator 5+. But that's a big lift, thus the bandaid.
    */
    tableBuilt: () => {
        // DNDA-1406: Table headers are missing required parent role (row)
        const headers = document.querySelectorAll('.tabulator-header');
        headers.forEach(header => {
            header.setAttribute('role', 'row');
        });

        // DNDA-1411: Grouped columns use invalid role "columngroup" and invalid attribute "aria-title"
        const groups = document.querySelectorAll('.tabulator-col.tabulator-col-group[role="columngroup"]');
        groups.forEach(group => {
            const title = group.getAttribute('aria-title');
            group.removeAttribute('aria-title');
            if (title) {
                group.setAttribute('aria-label', title);
            }
            group.setAttribute('role', 'columnheader');
        });
    },
    // TODO: Need to update to tabulator 5 for this to work. Test once that's done.
    // Set default values for all columns
    // columnDefaults: {
    //     accessor: (value, data, type, params, column) => {
    //         console.log('accessor', value, data, type, params, column);
    //         return value ?? '';
    //     }
    // },
}